import { render, staticRenderFns } from "./GameSmsList.vue?vue&type=template&id=102b6bc6&scoped=true"
import script from "./GameSmsList.vue?vue&type=script&lang=ts"
export * from "./GameSmsList.vue?vue&type=script&lang=ts"
import style0 from "./GameSmsList.vue?vue&type=style&index=0&id=102b6bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102b6bc6",
  null
  
)

export default component.exports